import { render, staticRenderFns } from "./StorificationTab.vue?vue&type=template&id=f9e5428a"
import script from "./StorificationTab.vue?vue&type=script&lang=js"
export * from "./StorificationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9e5428a')) {
      api.createRecord('f9e5428a', component.options)
    } else {
      api.reload('f9e5428a', component.options)
    }
    module.hot.accept("./StorificationTab.vue?vue&type=template&id=f9e5428a", function () {
      api.rerender('f9e5428a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/StorificationTab.vue"
export default component.exports